import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { getTimeSpanString, sortTimeSlots } from './time-utils';

export const TimeRangesView = ({
  timeSlots,
  i18n,
}) => {
  if (_.isEmpty(timeSlots)) {
    return (
      <div className="cell-placeholder">{i18n.getString(_TL_('Closed'))}</div>
    );
  }

  const slotElements = sortTimeSlots(timeSlots).map((timeSlot) => {
    const str = getTimeSpanString(timeSlot, i18n);
    return (
      <div
        className="cell-time-slot"
        key={str}
      >
        {str}
      </div>
    );
  });

  return (
    <React.Fragment>
      {slotElements}
    </React.Fragment>
  );
};

TimeRangesView.propTypes = {
  timeSlots: PropTypes.arrayOf(PropTypes.object).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
